import { render, staticRenderFns } from "./batch-difference-modal.vue?vue&type=template&id=138196ee&scoped=true"
import script from "./batch-difference-modal.vue?vue&type=script&lang=js"
export * from "./batch-difference-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138196ee",
  null
  
)

export default component.exports